(function () {
  function initTimeline(root) {
    if (!root || root.dataset.shkInit === 'true') return;
    root.dataset.shkInit = 'true';

    var stages = root.querySelectorAll('.shk-tw__stage');
    if (!stages.length) return;

    var reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      stages.forEach(function (stage) {
        stage.classList.add('is-inview');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Toggle both ways: highlight on the way down, un-highlight on the way back up.
          entry.target.classList.toggle('is-inview', entry.isIntersecting);
        });
      },
      { threshold: 0.25, rootMargin: '0px 0px -35% 0px' }
    );

    stages.forEach(function (stage) {
      observer.observe(stage);
    });
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.querySelectorAll) {
      context.querySelectorAll('.shk-tw').forEach(initTimeline);
    }
    // In case the theme editor swaps in a section whose root itself matches
    if (context.matches && context.matches('.shk-tw')) {
      initTimeline(context);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Re-init when a section is added/edited in the theme customizer
  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });
})();